import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'
import { useNavigate } from 'react-router-dom'
import { Button, Scroller } from 'components'
import styles from './index.module.css'

const ThinkIntro = () => {

	const App = useApp()
	const navigate = useNavigate() 



	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: undefined,
		})

		App.setShowNav(false)
		App.setMainClass("white")
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const onAgree = () => {
	    navigate("/thinkpool/thinkInfo",{replace:true})
	}



	return (
		<div className="page">
			<div className="flex_1 padding center-cont">
				<div className="slider">
					<ul>
						<Scroller dotsStyle={styles.dotsStyle} dotStyle={styles.dotStyle} activeDotStyle={styles.activeDotStyle}>
							<li style={{ width: '100%' }} className={`scrollerItem ${styles.scrollerItem}`}>
								<i className="icon icon_thinkpool_intro01" />
								<h3 className="intro-tit mt_20">AI가 알려주는 내 종목 분석</h3>
								<p className="intro-sub-tit mt_10">
									내가 보유하고 있는 종목을<br />
									AI가 다양하게 분석해드려요!
								</p>
							</li>
							<li style={{ width: '100%' }} className={`scrollerItem ${styles.scrollerItem}`}>
								<i className="icon icon_thinkpool_intro02" />
								<h3 className="intro-tit mt_20">자세한 매매신호는 AI프리미엄으로!</h3>
								<p className="intro-sub-tit mt_10">
									보유종목의 매매신호를 알고 싶다면<br />
									AI프리미엄을 구매하세요!
								</p>
							</li>
						</Scroller>
					</ul>
				</div>
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big" onClick={() => onAgree()}>시작하기</Button>
			</div>

			{/*<CommonAgreeLayer show={showAgreeLayer} closeLayer={() => setShowAgreeLayer(false)} onAgree={onAgree} agreeNow={false} termsCategoryCd="STOCK"  buttonText="모두 동의하고 시작"/>*/}
			{/* <TermsLayer show={showLayer} closeLayer={closeLayer} /> */}
		</div>
	)
}

// const TermsLayer = ({ show, closeLayer }) => {
// 	return (
// 		<LayerBottom title="약관동의" show={show} closeLayer={closeLayer} outside={
// 			<div className="button-group">
// 				<Button className="btn btn--big btn-layer" disabled >동의하고 시작</Button>
// 			</div>
// 		}>
// 			<div>
// 				<div className="flex-justify_between align_center">
// 					<div className="flex">
// 						<i className={`mr_10 checkMark`} />
// 						<span className="flex_1 flex-align_center"><strong className="mr_5">[필수]</strong> 개인정보 제3자 제공동의</span>
// 					</div>
// 					<i className="icon icon_arrow_sm right" />
// 				</div>
// 			</div>
// 		</LayerBottom>
// 	)
// }

export default ThinkIntro